import React from "react";

const Ad2ShopByBrand = () => {
  return (
    <>
      <section className="ShopByBrand">
        <div className="container">
          <div className="row BrandCon ">
            <h1 className="mb-5">Shop by Brand</h1>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-1.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-2.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-3.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-4.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-5.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-6.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-7.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-8.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-9.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-10.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-11.png")} alt="imaageo" />
            </div>
            <div className="col-lg-2 col-sm-6">
              <img src={require("./imges/brand-12.png")} alt="imaageo" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Ad2ShopByBrand;
